var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebsite11Logo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 51,
    viewBox: "0 0 178 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1402_1574)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.3693 21.8257H36.7123C36.7367 20.3853 36.5172 19.0181 36.0293 17.7486C34.1022 12.1579 28.0282 8.54468 19.2465 8.54468C7.80595 8.54468 0.853775 13.1344 0.853775 21.1421C0.853775 26.8793 6.26915 30.5413 13.636 32.47C19.027 33.9348 25.5645 35.0823 25.5645 38.4513C25.5645 40.8683 23.0519 42.4063 19.1978 42.4063C15.5387 42.4063 12.953 41.0392 12.0748 38.9396C11.7821 38.3293 11.6357 37.6213 11.6357 36.8889H0C0 38.3537 0.292723 39.7941 0.902563 41.1368C3.07359 47.0449 9.53789 51.0487 19.0514 51.0487C31.053 51.0487 37.2978 45.8242 37.249 37.9631C37.2002 31.6888 32.2483 28.4418 24.2716 26.2201C18.6611 24.6821 12.0748 23.2172 12.0748 20.2876C12.0748 17.9439 14.563 16.65 18.4659 16.65C21.7103 16.65 23.9789 17.8218 24.8327 19.7261C25.1742 20.2876 25.3937 21.02 25.3693 21.8257Z",
    fill: "#022F40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7911 10.0095H43.1035V19.067H54.2026V50.9999H65.7652V19.067H76.7911V10.0095Z",
    fill: "#022F40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.852 9.98511L157.753 25.7319L149.655 9.98511H137.507L152.07 35.9856V50.9999H163.608V35.9856L178 9.98511H165.852Z",
    fill: "#022F40"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.676 51V24.023L109.112 12.6951L93.6713 24.023V51H83.4016V18.8229L109.088 0L134.945 18.8229V51H124.676Z",
    fill: "#E95A2C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.186 38.3049C112.015 38.3049 114.308 40.6242 114.308 43.4318V51H104.039V43.4318C104.039 40.5998 106.356 38.3049 109.186 38.3049Z",
    fill: "#E95A2C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.186 23.2905C112.015 23.2905 114.308 25.5854 114.308 28.4174V28.6859C114.308 31.5179 112.015 33.8128 109.186 33.8128C106.356 33.8128 104.063 31.5179 104.063 28.6859V28.4174C104.039 25.6098 106.332 23.2905 109.186 23.2905Z",
    fill: "#063647"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1402_1574"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 178,
    height: 51,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite11Logo);
export default __webpack_public_path__ + "static/media/website-11-logo.5ff2e7d2e72aee7eabf7bf5dbdc5e6a2.svg";
export { ForwardRef as ReactComponent };